// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nuverandaskriftwrap {
    display: flex;
    width: 100%;
    padding-bottom: 30px;
    flex-direction: column;
    align-items: center;
    background-color: var(--gray-more-lighter);
}

.div-block-57 {
    display: flex;
    max-width: 70%;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
}

.text-block-36 {
    margin-top: 0px;
    margin-bottom: 0px;
    padding-bottom: 6px;
    border-style: none none solid;
    border-width: 1px;
    border-color: var(--blue-darker);
    color: var(--gray-darkest);
    font-size: 20px;
    font-weight: 700;
    text-align: center;
}

.stadawrap {
    display: flex;
    width: 90%;
    margin-top: 15px;
    margin-bottom: 5px;
    flex-direction: row;
    justify-content: space-between;
}

.statusgbleft {
    font-family: 'Hvd fonts brixslab', sans-serif;
    color: var(--gray-dark);
    font-size: 15px;
    width: 40%;
}

.statusgbright {
    font-family: 'Hvd fonts brixslab', sans-serif;
    color: var(--gray-dark);
    font-size: 15px;
    width: 40%;
    text-align: right;
}

.stadatext {
    font-family: 'Hvd fonts brixslab', sans-serif;
    color: var(--gray-darkest);
    font-size: 17px;
    font-style: normal;
    font-weight: 500;
    width: 20%;
}

.stadatext2 {
    font-family: 'Hvd fonts brixslab', sans-serif;
    color: var(--gray-darkest);
    font-size: 17px;
    font-style: normal;
    font-weight: 500;
    width: 20%;
    white-space: nowrap;
}

.stadatextCenter {
    text-align: center;
}

.textiCurrentData {
    width: 400px;
    margin-top: 20px;
    color: var(--gray-darkest);
    font-size: 20px;
    line-height: 28px;
    font-weight: 300;
    text-align: center;
    font-family: 'Hvd fonts brixslab', sans-serif;
}

@media (max-width: 991px) {
    .nuverandaskriftwrap {
        width: 100%;
    }
}

@media (max-width: 479px) {
    .div-block-57 {
        width: 100%;
        max-width: 90%;
    }

    .stadawrap {
        justify-content: space-between;
        width: 100%;
    }

    .statusgb {
        font-size: 14px;
    }

    .endalausarminuturtexti {
        font-size: 14px;
    }

    .textiCurrentData {
        width: 90%;
        font-size: 18px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/utgardur/DataLayout/DataLayout.css"],"names":[],"mappings":"AAAA;IAII,aAAa;IACb,WAAW;IACX,oBAAoB;IAKpB,sBAAsB;IAItB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IAII,aAAa;IACb,cAAc;IAKd,sBAAsB;IAItB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;IACjB,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IAII,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAKlB,mBAAmB;IAInB,8BAA8B;AAClC;;AAEA;IACI,6CAA6C;IAC7C,uBAAuB;IACvB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,6CAA6C;IAC7C,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QAII,8BAA8B;QAC9B,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;AACJ","sourcesContent":[".nuverandaskriftwrap {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    padding-bottom: 30px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    background-color: var(--gray-more-lighter);\n}\n\n.div-block-57 {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    max-width: 70%;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-top: 30px;\n}\n\n.text-block-36 {\n    margin-top: 0px;\n    margin-bottom: 0px;\n    padding-bottom: 6px;\n    border-style: none none solid;\n    border-width: 1px;\n    border-color: var(--blue-darker);\n    color: var(--gray-darkest);\n    font-size: 20px;\n    font-weight: 700;\n    text-align: center;\n}\n\n.stadawrap {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 90%;\n    margin-top: 15px;\n    margin-bottom: 5px;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n}\n\n.statusgbleft {\n    font-family: 'Hvd fonts brixslab', sans-serif;\n    color: var(--gray-dark);\n    font-size: 15px;\n    width: 40%;\n}\n\n.statusgbright {\n    font-family: 'Hvd fonts brixslab', sans-serif;\n    color: var(--gray-dark);\n    font-size: 15px;\n    width: 40%;\n    text-align: right;\n}\n\n.stadatext {\n    font-family: 'Hvd fonts brixslab', sans-serif;\n    color: var(--gray-darkest);\n    font-size: 17px;\n    font-style: normal;\n    font-weight: 500;\n    width: 20%;\n}\n\n.stadatext2 {\n    font-family: 'Hvd fonts brixslab', sans-serif;\n    color: var(--gray-darkest);\n    font-size: 17px;\n    font-style: normal;\n    font-weight: 500;\n    width: 20%;\n    white-space: nowrap;\n}\n\n.stadatextCenter {\n    text-align: center;\n}\n\n.textiCurrentData {\n    width: 400px;\n    margin-top: 20px;\n    color: var(--gray-darkest);\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 300;\n    text-align: center;\n    font-family: 'Hvd fonts brixslab', sans-serif;\n}\n\n@media (max-width: 991px) {\n    .nuverandaskriftwrap {\n        width: 100%;\n    }\n}\n\n@media (max-width: 479px) {\n    .div-block-57 {\n        width: 100%;\n        max-width: 90%;\n    }\n\n    .stadawrap {\n        -webkit-box-pack: justify;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: justify;\n        justify-content: space-between;\n        width: 100%;\n    }\n\n    .statusgb {\n        font-size: 14px;\n    }\n\n    .endalausarminuturtexti {\n        font-size: 14px;\n    }\n\n    .textiCurrentData {\n        width: 90%;\n        font-size: 18px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
